import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { AcceptTermsDialog as View } from './view'

export { acceptTerms, isTermsAccepted } from './lib'

export const AcceptTermsDialog = {
    View,
    model,
}

model.showFx.use(modalOpener(AcceptTermsDialog.View))
